"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = List;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classnames = _interopRequireDefault(require("classnames"));

function List(props) {
  return (0, _preact.h)("ul", {
    className: (0, _classnames.default)('main-menu-list', props.className)
  }, props.children.map(function (item, idx) {
    var _props$getItemProps;

    return (0, _preact.h)("li", (0, _extends2.default)({
      className: "main-menu-list__item",
      key: idx
    }, (_props$getItemProps = props.getItemProps) === null || _props$getItemProps === void 0 ? void 0 : _props$getItemProps.call(props, idx)), item);
  }));
}